const pendingInvitationStorageKey = "merry.pending-team-invitation";

let memoryToken: string | null = null;

function sessionStorageAvailable() {
  return typeof window !== "undefined" && window.sessionStorage != null;
}

export const pendingInvitationVault = {
  captureFromCurrentLocation() {
    if (typeof window === "undefined") return null;

    const parameters = new URLSearchParams(window.location.hash.slice(1));
    const token = parameters.get("invite")?.trim() ?? "";
    if (token) this.set(token);

    if (window.location.hash) {
      window.history.replaceState(
        window.history.state,
        "",
        `${window.location.pathname}${window.location.search}`,
      );
    }
    return this.get();
  },
  clear() {
    memoryToken = null;
    if (!sessionStorageAvailable()) return;
    try {
      window.sessionStorage.removeItem(pendingInvitationStorageKey);
    } catch {
      // 隐私模式可能禁用 storage，内存副本仍可完成当前页面流程。
    }
  },
  get() {
    if (memoryToken) return memoryToken;
    if (!sessionStorageAvailable()) return null;
    try {
      memoryToken =
        window.sessionStorage.getItem(pendingInvitationStorageKey)?.trim() ||
        null;
    } catch {
      memoryToken = null;
    }
    return memoryToken;
  },
  set(token: string) {
    memoryToken = token.trim() || null;
    if (!sessionStorageAvailable()) return;
    try {
      if (memoryToken) {
        window.sessionStorage.setItem(
          pendingInvitationStorageKey,
          memoryToken,
        );
      } else {
        window.sessionStorage.removeItem(pendingInvitationStorageKey);
      }
    } catch {
      // 当前标签页仍保留内存副本，令牌不会降级到 localStorage。
    }
  },
};
